<template>
  <div>
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
    <div class="bb-clients-list" ref="bbClientTable">
      <table class="bb-table">
        <thead class="bb-table-header">
        <tr class="bb-table-header-row">
          <th class="bb-table-header__item bb-table-header__item_hide"/>
          <th class="bb-table-header__item bb-table-header__item_checkbox" @click="checkedAll">
            <checkbox :animation="true"
                      :value="allContactsChecked"
                      @checkboxChange="checkedAll"/>
          </th>
          <th class="bb-table-header__item bb-table-header__item_counter"></th>
          <th
            v-if="!isPartners"
            class="bb-table-header__item bb-table-header__item_flags"
            v-click-outside="() => this.openFilterCitizenship = false"
            ref="partnerRefs"
            @click.stop="onOpenCountry($event)"
          >
            <div
              class="bb-table-header__item_select"
              :class="[getActiveFilter(filterByCitizenship) && 'bb-table-header__icon-active']"
            >
              CITIZENSHIP
              <i class="icon-arrow-select"/>
              <transition name="fade-form">
                <FilterPopup class="bb-clients-list__filter"
                             v-show="openFilterCitizenship"
                             :list="countriesList"
                             :checked="filter['passports.citizenship[]=']"
                             :positionStyle="positionStyle"
                             :flags="true"
                             :searchable="true"
                             section="citizenship"
                             @setData="setDataFilter"/>
              </transition>
            </div>
          </th>
          <th
            v-if="!isPartners"
            class="bb-table-header__item bb-table-header__item_pointer bb-table-header__item_partner">
            <div class="bb-table-header__item_select">
              <div
                :class="[columnPartner.activeClass && 'bb-table-header__icon-active']"
                v-html="PartnerIcon()"
              />
              <BBPFilterPopup
                :isOpen="filterOpen === columnPartner.prop"
                :column="columnPartner"
                @onChangeFilter="onChangeFilter"
              />
            </div>
          </th>
          <th class="bb-table-header__item bb-table-header__item_vip"/>
          <th
            class="bb-table-header__item bb-table-header__item_pointer bb-table-header__item_first-name"
            @click="sortByColumn('firstName')"
          >
            <div class="bb-table-header__item_name">
              FIRST NAME
              <i class="icon-arrow-sort bb-table-header__sort-icon"
                 :class="{'bb-table-header__sort-icon_active': filterByColumn === 'firstName'}"/>
            </div>
          </th>
          <th class="bb-table-header__item bb-table-header__item_pointer" @click="sortByColumn('lastName')">
            <div class="bb-table-header__item_name">
              LAST NAME
              <i class="icon-arrow-sort bb-table-header__sort-icon"
                 :class="{'bb-table-header__sort-icon_active': filterByColumn === 'lastName'}"/>
            </div>
          </th>
          <th
            v-if="!isPartners"
            class="bb-table-header__item"
          >
            <div
              class="bb-table-header__item_select"
              :class="[getActiveFilter(filterByBank) && 'bb-table-header__icon-active']"
              v-click-outside="() => this.openFilterBanks = false"
              @click.stop="openFilterBanks = !openFilterBanks"
            >
              BANK
              <i class="icon-arrow-select"/>
              <transition name="fade-form">
                <FilterPopup
                  v-show="openFilterBanks"
                  class="bb-clients-list__filter bb-clients-list__filter_banks"
                  :list="banksList"
                  :checked="filter['banks.bankName[]=']"
                  section="banks"
                  @setData="setDataFilter"
                />
              </transition>
            </div>
          </th>
          <th class="bb-table-header__item">
            <div>
              COMPANY
            </div>
          </th>
          <th class="bb-table-header__item bb-table-header__item_pointer" @click="sortByColumn('nickName')">
            <div class="bb-table-header__item_name">
              NICKNAME
              <i class="icon-arrow-sort bb-table-header__sort-icon"
                 :class="{'bb-table-header__sort-icon_active': filterByColumn === 'nickName'}"/>
            </div>
          </th>
          <th class="bb-table-header__item
                     bb-table-header__item_pointer
                     bb-table-header__item_icon
                     bb-table-header__item_center"
              @click="onFilterClick(columnBc.prop)"
          >
            <div
              class="bb-table-header__item_select"
              :class="[columnBc.activeClass && 'bb-table-header__icon-active']"
            >
              BC
              <i class="icon-arrow-select"/>
              <BBPFilterPopup
                :isOpen="filterOpen === columnBc.prop"
                :column="columnBc"
                @onChangeFilter="onChangeFilter"
              />
            </div>
          </th>
          <th class="bb-table-header__item
                     bb-table-header__item_pointer
                     bb-table-header__item_icon
                     bb-table-header__item_center"
              @click="onFilterClick(columnPm.prop)"
          >
            <div
              class="bb-table-header__item_select"
              :class="[columnPm.activeClass && 'bb-table-header__icon-active']"
            >
              PM
              <i class="icon-arrow-select" />
              <BBPFilterPopup
                :isOpen="filterOpen === columnPm.prop"
                :column="columnPm"
                @onChangeFilter="onChangeFilter"
              />
            </div>
          </th>
          <th class="bb-table-header__item bb-table-header__item_risk">
            <div
              class="bb-table-header__item_select"
              :class="[getActiveFilter(filterByRisk) && 'bb-table-header__icon-active']"
              v-click-outside="() => this.openFilterRisk = false"
              @click.stop="openFilterRisk = !openFilterRisk"
            >
              RISK
              <i class="icon-arrow-select"/>
              <transition name="fade-form">
                <FilterPopup class="bb-clients-list__filter bb-clients-list__filter_status"
                             v-show="openFilterRisk"
                             :list="contactRisk"
                             :checked="filter['riskStatus[]=']"
                             section="riskStatus"
                             @setData="setDataFilter"/>
              </transition>
            </div>
          </th>
          <th
            v-if="contactType === 1"
            class="bb-table-header__item bb-table-header__item_icon"
          >
            <div v-html="phoneIcon" />
          </th>
          <th class="bb-table-header__item bb-table-header__item_extra">
            <div
              class="bb-table-header__item_select"
              :class="[getActiveFilter({...filterByExtra, ...filterByLang}) && 'bb-table-header__icon-active']"
              v-click-outside="() => this.openFilterExtra = false"
              @click.stop="openFilterExtra = !openFilterExtra"
            >
              EXTRA
              <i class="icon-arrow-select"/>
              <transition name="fade-form">
                <FilterPopup class="bb-clients-list__filter bb-clients-list__filter_extra"
                             v-show="openFilterExtra"
                             :list="contactExtra"
                             :checked="`${filter['languages[]=']},${filter['phone[]=']},${filter['email[]=']}`"
                             section="extra"
                             @setData="setDataFilter"/>
              </transition>
            </div>
          </th>
          <th class="bb-table-header__item bb-table-header__item_hide"/>
        </tr>
        </thead>
        <tbody class="bb-table-body">
        <tr class="bb-table-body-row bb-table-body-row_pointer"
            v-for="(contact, index) in contactsList.clients"
            :key="contact.id"
            @click="contactCheckedChange(true, contact.id, contact)"
            @mouseenter="setActiveRow(index)"
            @mouseleave="rowActive = true, deleteConfirmIndex = true"
            :class="{'bb-table-body-row_active':rowActive === index}">
          <td>
            <div class="bb-table-body-row__after bb-table-body-row__after_table" :ref="'bbRowAfter'+index"/>
          </td>
          <td class="bb-table-body__item bb-table-body__item_checkbox">
            <checkbox :name="contact.id"
                      :animation="true"
                      :section="contact"
                      :value="checkedContactsIds.includes(contact.id)"
                      @checkboxChange="contactCheckedChange"/>
          </td>
          <td class="bb-table-body__item bb-table-body__item_counter">
            <div class="bb-table-counter">
              <span class="bb-table-counter__number">{{(index + 1) + (defLimit * (currentPage - 1))}}</span>
            </div>
          </td>
          <td class="bb-table-body__item bb-table-body__item_flags" v-if="!isPartners">
            <ListCountyFlags :passports="contact.passports"/>
          </td>
          <td
            v-if="!isPartners"
            class="bb-table-body__item"
            @click.stop
          >
            <router-link
              v-if="contact.partner"
              target="_blank"
              :to="goOnPartner(contact)"
            >
              <div
                class="bb-table-body__partner"
                v-html="PartnerIcon()"
              />
            </router-link>
          </td>
          <td class="bb-table-body__item bb-table-body__item_vip" @click.stop="goToClientCard(contact)">
            <i class="icon-crown" v-if="contact.vip"/>
          </td>
          <td class="bb-table-body__item bb-table-body__item_username bb-clients-list__hover-cell">
            <div class="bb-table-body-block" @click.stop>
              <router-link
                class="bb-table-body-first-name"
                target="_blank"
                :to="{name: 'ContactCard', params: {id: contact.id, contactType: contact.contactType}}"
              >
                <div class="bb-clients-list-avatar">
                  <img class="bb-table-body-first-name__avatar" v-if="contact.image" :src="contact.image.path">
                  <i class="icon-user bb-table-body-first-name__avatar bb-table-body-first-name__avatar_icon" v-else/>
                  <div class="bb-clients-list-avatar-icons">
                    <i class="icon-message bb-clients-list-avatar-icons__icon"
                       v-if="contact.email[0]"/>
                    <i class="icon-phone bb-clients-list-avatar-icons__icon bb-clients-list-avatar-icons__icon_phone"
                       v-if="contact.phone[0]"/>
                  </div>
                </div>
                <span class="bb-table-body-first-name__name">{{contact.firstName}}</span>
              </router-link>
              <div
                v-if="infoPopup(contact)"
                @click="onPopupHandler($event, contact)"
                v-html="InfoIcon()"
              />
            </div>
          </td>
          <td class="bb-table-body__item bb-clients-list__hover-cell">
            <router-link
              class="bb-table-body-first-name"
              target="_blank"
              :to="{name: 'ContactCard', params: {id: contact.id, contactType: contact.contactType}}"
            >
              {{contact.lastName}}
            </router-link>
          </td>
          <td class="bb-table-body__item" v-if="!isPartners">
            <div class="bb-clients-list-banks">
              <div v-for="(bank, bankIndex) in contact.banks"
                   :key="'client_bank_' + bank.bankName + bank.bankNo + bankIndex">
                {{getBankName(bank.bankName)}}
              </div>
            </div>
          </td>
          <td class="bb-table-body__item">
            <div>
              {{contact.clientCompany}}
            </div>
          </td>
          <td class="bb-table-body__item bb-clients-list__hover-cell">
            <router-link
              class="bb-table-body-first-name"
              target="_blank"
              :to="{name: 'ContactCard', params: {id: contact.id, contactType: contact.contactType}}"
            >
              {{contact.nickName}}
            </router-link>
          </td>
          <td
            class="bb-table-body__item bb-table-body__item_capitalize"
            @click.stop
          >
            <div v-if="contact.businessConsultant">
              <BBAddUserSelect
                :row="contact"
                :column="columnBc"
                @update="onUpdateClient"
              />
            </div>
          </td>
          <td
            class="bb-table-body__item bb-table-body__item_capitalize"
            @click.stop
          >
            <div v-if="contact.projectManager">
              <BBAddUserSelect
                :row="contact"
                :column="columnPm"
                @update="onUpdateClient"
              />
            </div>
          </td>

          <td class="bb-table-body__item">
            <div :class="[`bb-table-body__item_${getColorRisk(contact.riskStatus)}`]">
              {{getRiskName(contact.riskStatus)}}
            </div>
          </td>

          <td v-if="contactType === 1" class="bb-table-body__item">
            <span
              v-html="phoneIcon"
              @click.stop="onCommunicationPopupHandler($event, contact)"
              class="phone-item-icon"
              :style="{
                  color: contact.statusLastCommunication
                      ? clientCommunicationStatus[contact.statusLastCommunication]
                      : clientCommunicationStatus[3],
                  cursor: !contact.statusLastCommunication || contact.statusLastCommunication === 3
                          ? 'initial'
                          : 'pointer'
            }"
            />
          </td>

          <td class="bb-table-body__item">
            <Toolbar v-if="rowActive === index"
                     :delete-index="deleteConfirmIndex"
                     :index="index"
                     :item="contact"
                     :isFlexStart="true"
                     @openEdit="goToClientCard(contact, true)"
                     @deleteOpen="deleteConfirmIndex = index"
                     @deleteClose=" deleteConfirmIndex = false"
                     @deleteItem="openDoubleDelete = index"/>
            <DoubleDelete v-if="openDoubleDelete === index"
                          :id="contact.id"
                          :password="passwordClientDelete"
                          :title="contact.nickName"
                          @close="openDoubleDelete = false"
                          @delete="deleteContact"/>
          </td>

          <td class="bb-table-body__item"/>
        </tr>
        </tbody>
      </table>
    </div>
    <Pagination :data="contactsList" :getQuery="getContactsList" :limit="defLimit" class="bb-pagination"/>
    <transition
      v-if="isShowPopupInfo"
      name="bounce"
      appear
    >
    <BBPopupInfoTwo
      :items="itemsPopup"
      :popupStyle="popupStyle"
      @close="isShowPopupInfo = false"
    />
    </transition>
    <transition
      v-if="isShowPopupClientCommunication"
      name="bounce"
      appear
    >
      {{lastClientCommunicationDataPopup}}
      <BBPopupInfoCommunication
        :data="lastClientCommunicationDataPopup"
        :popupStyle="popupStyle"
        @close="isShowPopupClientCommunication = false"
      />
    </transition>
  </div>
</template>

<script>
import Toolbar from '@/components/Main/Toolbar/Toolbar'
import ContactsApi from '@/api/Contacts/api'
import UsersListApi from '@/api/UsersList/api'
import UserApi from '@/api/User/api'
import {contactStatus, contactExtra, contactRisk, clientCommunicationStatus} from '@/constants/clientInfo'
import {InfoIcon, PartnerIcon, PhoneIcon} from '@/constants/icon'
import DoubleDelete from '@/components/Main/DoubleDelete/DoubleDelete'
import Pagination from '@/components/Main/Pagination/Pagination'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import {debounce, get, set, map, find, filter, findIndex, reduce, compact, cloneDeep} from 'lodash'
import avatarUserDefault from '@/assets/images/avatar-user-default.png'
import {passwordClientDelete} from '@/constants/passwordForDelete'
import Checkbox from '@/components/Main/Inputs/checkbox'
import CountryFlag from '@/components/Main/CountryFlag/CountryFlag'
import countriesList from '@/constants/countriesList'
import FilterPopup from '@/components/Main/FilterPopup/FilterPopup'
import personalBanks from '@/constants/personalBanks'
import ListCountyFlags from '@/components/Main/CountryFlag/ListCountyFlags'
import BBImage from '@/components/Main/BBImage/BBImage'
import queryString from 'query-string'
import BBAddUserSelect from '@/components/Main/BBAddUserSelect/BBAddUserSelect'
import {departmentCategory} from '@/constants/departmentCategory'
import BBPFilterPopup from '@/components/Main/BBFilterPopup/BBFilterPopup'
import BBPopupInfoTwo from '@/components/Main/BBPopupInfo/BBPopupInfoTwo'
import {PARTNER_ID} from '@/constants/clientType'

import BBPopupInfoCommunication from '@/components/Main/BBPopupInfo/BBPopupInfoCommunication.vue'

export default {
  name: 'ContactsTable',
  props: ['contactType', 'statusType', 'searchValue'],
  components: {
    BBPopupInfoTwo,
    BBPFilterPopup,
    BBAddUserSelect,
    ListCountyFlags,
    Checkbox,
    BBImage,
    Toolbar,
    DoubleDelete,
    Pagination,
    LoaderFly,
    CountryFlag,
    FilterPopup,
    BBPopupInfoCommunication
  },
  data: function () {
    return {
      openFilterCitizenship: false,
      openFilterStatus: false,
      openFilterRisk: false,
      openFilterExtra: false,
      openFilterBanks: false,
      filterByColumn: 'firstName',
      filterByStatus: {},
      filterByRisk: {},
      filterByExtra: {},
      filterByLang: {},
      filterByCitizenship: {},
      filterByBank: {},
      filterByImg: '',
      sortedColumn: false,
      loaderRun: false,
      defLimit: 30,
      currentPage: 1,
      fullDataContacts: '',
      openDoubleDelete: false,
      rowActive: false,
      deleteConfirmIndex: false,
      activeTab: 'clients',
      queryClients: {},
      clientStatus: contactStatus,
      clientRisk: contactRisk,
      avatarUserDefault: avatarUserDefault,
      searchWords: '',
      countriesList: [],
      checkedContacts: [],
      passwordClientDelete: passwordClientDelete,
      contactRisk: contactRisk,
      contactStatus: contactStatus,
      banksList: personalBanks,
      filter: {},
      allContactsChecked: false,
      clientCheckedNotEmail: false,
      resetClientCheck: false,
      columnBc: {
        items: [],
        options: [],
        prop: 'businessConsultant',
        label: 'username',
        activeClass: false
      },
      columnPm: {
        items: [],
        options: [],
        prop: 'projectManager',
        label: 'username',
        activeClass: false
      },
      columnPartner: {
        items: [],
        options: [],
        prop: 'partner',
        label: 'nickName',
        isAllFilter: 'All Partners',
        isActiveAll: false,
        activeClass: false
      },
      filterOpen: '',
      isShowPopupInfo: false,
      popupStyle: {},
      itemsPopup: [],
      lastClientCommunicationDataPopup: [],
      isShowPopupClientCommunication: false,
      InfoIcon,
      PartnerIcon,
      positionStyle: {},
      phoneIcon: PhoneIcon(),
      clientCommunicationStatus: clientCommunicationStatus
    }
  },
  computed: {
    contactExtra () {
      return this.clientCheckedNotEmail ? this.contactExtraCheck() : contactExtra
    },
    isPartners () {
      return this.contactType === 2
    },
    checkedContactsIds () {
      return this.checkedContacts.map(contact => contact.id)
    },
    activeCompany: function () {
      return this.$store.getters.activeCompany
    },
    contactsList: {
      get: function () {
        return this.$store.getters.contactsList
      },
      set: function (data) {
        this.$store.dispatch('setContactsList', data)
      }
    },
    users: {
      get: function () {
        return this.$store.getters.usersList
      },
      set: function (data) {
        this.$store.dispatch('setUsersList', data)
      }
    },
    clientInfo: {
      get: function () {
        return this.$store.getters.clientInfo
      },
      set: function (data) {
        this.$store.dispatch('setClientInfo', data)
      }
    },
    getWithSearch: function () {
      return debounce(this.getContactsList, 250)
    },
    mainScroll () {
      return this.$store.getters.mainScroll
    }
  },
  methods: {
    getActiveFilter (item) {
      const keys = Object.keys(item)
      return keys.some((el) => item[el])
    },
    goOnPartner ({ partner }) {
      return {
        name: 'ContactCard',
        params: {
          id: partner,
          contactType: PARTNER_ID
        }
      }
    },
    onOpenCountry () {
      const element = this.$refs.partnerRefs
      const { top, left, height } = element.getBoundingClientRect()
      this.openFilterCitizenship = !this.openFilterCitizenship
      this.positionStyle = {
        position: 'fixed',
        top: `${top + height}px`,
        left: `${left}px`
      }
    },
    onPopupHandler ({ target, clientX }, { clientChat, datePath }) {
      const { innerWidth = 0 } = window
      const { top, left, width, height } = target.getBoundingClientRect()
      this.isShowPopupInfo = !this.isShowPopupInfo
      this.popupStyle = {
        position: 'fixed',
        maxWidth: `${innerWidth - left - 50}px`,
        top: `${top + height + 7}px`,
        left: `${left + width - 21}px`
      }
      this.itemsPopup = []
      if (clientChat) this.itemsPopup = [...this.itemsPopup, {label: 'Client Chat:', value: clientChat}]
      if (datePath) this.itemsPopup = [...this.itemsPopup, {label: 'Data Path:', value: datePath}]
    },
    onCommunicationPopupHandler ({ target, clientX }, contact) {
      const {statusLastCommunication, lastClientCommunication} = contact

      if (!statusLastCommunication || statusLastCommunication === 3) return

      this.isShowPopupClientCommunication = !this.isShowPopupClientCommunication
      this.lastClientCommunicationDataPopup = []

      const { innerWidth = 0 } = window
      const { top, height, right } = target.getBoundingClientRect()

      this.popupStyle = {
        position: 'fixed',
        maxWidth: `${innerWidth / 3}px`,
        top: `${top + height + 7}px`,
        right: `${innerWidth - right - 10}px`
      }

      const { user, date, comment } = lastClientCommunication
      const { image } = user

      this.lastClientCommunicationDataPopup = [
        { label: 'Date:', value: date, type: 'date' },
        { label: 'Comment:', value: comment, type: 'string' },
        { label: 'User:', value: image ? image.path : null, type: 'image' }
      ]
    },
    infoPopup ({ clientChat, datePath }) {
      return clientChat || datePath
    },
    contactExtraCheck () {
      const newContactExtra = cloneDeep(contactExtra)
      return newContactExtra.map(el => {
        if (el.key === 'email') el.isCheck = this.clientCheckedNotEmail
        return el
      })
    },
    getBankName (bankId) {
      const bank = find(this.banksList, {id: bankId})
      return get(bank, 'name', '')
    },
    setDataFilter (data, item, section) {
      if (section === 'status') {
        set(this.filterByStatus, item.id, data)
        const resultFilter = this.filterData(this.filterByStatus)
        this.filter['status[]='] = resultFilter.join(',')
      } else if (section === 'citizenship') {
        set(this.filterByCitizenship, item.id, data)
        const resultFilter = this.filterData(this.filterByCitizenship)
        this.filter['passports.citizenship[]='] = resultFilter.join(',')
      } else if (section === 'riskStatus') {
        set(this.filterByRisk, item.id, data)
        const resultFilter = this.filterData(this.filterByRisk)
        this.filter['riskStatus[]='] = resultFilter.join(',')
      } else if (section === 'banks') {
        set(this.filterByBank, item.id, data)
        const resultFilter = this.filterData(this.filterByBank)
        this.filter['banks.bankName[]='] = resultFilter.join(',')
      } else if (section === 'extra') {
        const filterObject = item.key === 'languages' ? this.filterByLang : this.filterByExtra
        set(filterObject, item.id, data)
        const resultFilter = this.filterData(filterObject)
        if (resultFilter.includes('3')) {
          this.filter['phone[]='] = 3
        } else if (item.key === 'phone') {
          this.filter['phone[]='] = ''
        }
        if (resultFilter.includes('4')) {
          this.filter['email[]='] = 4
        } else if (item.key === 'email') {
          this.filter['email[]='] = ''
        }
        if (item.key === 'languages') {
          this.filter[`${item.key}[]=`] = resultFilter.join(',')
        }
      }
      this.filter.page = 1
      this.$router.replace({query: this.filter})
      this.getContactsList({limit: this.defLimit})
    },
    filterData (object) {
      return Object.keys(object).filter(key => {
        if (object[key]) return key
      })
    },
    contactCheckedChange (value, contactId, contact) {
      const index = findIndex(this.checkedContacts, {id: contactId})
      if (index !== -1) {
        this.checkedContacts.splice(index, 1)
      } else {
        this.checkedContacts.push(contact)
      }
    },
    filterByPartner (id, type, isActiveAll, isAll) {
      if (isAll) {
        delete this.filter[`${type}[]=`]
        if (isActiveAll) {
          this.filter['isPartner='] = 1
          this.$router.replace({query: this.filter})
          this.columnPartner.activeClass = true
        } else {
          delete this.filter['isPartner=']
          this.$router.replace({query: this.filter})
          this.columnPartner.activeClass = false
        }
      } else {
        delete this.filter['isPartner=']
        if (id) {
          this.filter[`${type}[]=`] = id
          this.$router.replace({query: this.filter})
          this.columnPartner.activeClass = true
        } else {
          delete this.filter[`${type}[]=`]
          this.$router.replace({query: this.filter})
          this.columnPartner.activeClass = false
        }
      }
    },
    filterByManager (id, type) {
      if (id) {
        this.filter[`${type}[]=`] = id
        this.$router.replace({query: this.filter})
        if (type === 'businessConsultant') this.columnBc.activeClass = true
        if (type === 'projectManager') this.columnPm.activeClass = true
      } else {
        delete this.filter[`${type}[]=`]
        this.$router.replace({query: this.filter})
        if (type === 'businessConsultant') this.columnBc.activeClass = false
        if (type === 'projectManager') this.columnPm.activeClass = false
      }
    },
    filterByImage (id, item, isAll) {
      const { prop, isActiveAll = false } = item
      if (prop === 'businessConsultant' || prop === 'projectManager') {
        this.filterByManager(id, prop)
      } else if (prop === 'partner') {
        this.filterByPartner(id, prop, isActiveAll, isAll)
      } else {
        if (this.filter[`${prop}[]=`]) {
          delete this.filter[`${prop}[]=`]
          this.$router.replace({query: this.filter})
        } else {
          this.filter[`${prop}[]=`] = id
          this.$router.replace({query: this.filter})
        }
      }
      this.getContactsList({limit: this.defLimit})
    },
    checkedAll () {
      if (this.allContactsChecked) {
        this.checkedContacts = []
        this.allContactsChecked = 0
        return
      }
      this.getContactsList({limit: 99999, check: true})
    },
    setActiveRow (index) {
      this.rowActive = index
      const widthTable = get(this.$refs, 'bbClientTable.offsetWidth', false)
      const afterElement = get(this.$refs, `bbRowAfter${index}`, [])
      if (widthTable && afterElement[0]) {
        afterElement[0].style.width = widthTable + 'px'
      }
    },
    sortByColumn (column) {
      const sorted = column + '&sort[]=-1'
      if (this.filter['sort[]='] && this.filter['sort[]='] === sorted) {
        this.filter['sort[]='] = column
        this.filterByColumn = ''
      } else {
        this.filter['sort[]='] = sorted
        this.filterByColumn = column
      }
      this.$router.replace({query: this.filter})
      this.getContactsList({limit: this.defLimit})
    },
    getStatusName (id) {
      const status = find(this.clientStatus, elem => elem.id === +id)
      if (status) {
        return status.name
      }
      return status
    },
    getColorRisk (id) {
      const colorRisk = find(this.clientRisk, elem => elem.id === id) || {}
      return colorRisk ? colorRisk.color : ''
    },
    getRiskName (id) {
      const risk = find(this.clientRisk, elem => elem.id === id)
      return risk ? risk.name : ''
    },
    goToClientCard (contact) {
      this.clientInfo = contact
      this.$router.push({
        name: 'ContactCard',
        params: {
          id: contact.id,
          contactType: contact.contactType
        }
      })
    },
    getQueryFilters () {
      const paramsFilter = [
        {prop: 'status', target: this.filterByStatus},
        {prop: 'riskStatus', target: this.filterByRisk},
        {prop: 'passports.citizenship', target: this.filterByCitizenship},
        {prop: 'banks.bankName', target: this.filterByBank},
        {prop: 'languages', target: this.filterByLang}
      ]
      const allFilters = paramsFilter.map(filter => {
        return reduce(filter.target, (res, val, key) => {
          if (val) res += `&${filter.prop}[]=${key}`
          return res
        }, '')
      })
      if (this.filterByExtra.email) allFilters.push('&email[]')
      if (this.filterByExtra.phone) allFilters.push('&phone[]')
      return compact(allFilters).join('&')
    },
    scrollPageTop () {
      const scroll = get(this.mainScroll, 'target', '')
      if (!scroll) return
      scroll.scrollTop = 0
    },
    getContactsList ({limit, page = this.filter.page || 1, check}) {
      this.currentPage = page
      this.filter.page = page
      this.scrollPageTop()
      this.loaderRun = true
      const obj = this.$route.query
      obj.page = Number(obj.page)
      this.currentPage = Number(this.currentPage)
      if (obj.page !== this.currentPage) this.$router.replace({query: {...this.$route.query, page}})
      const query = map(this.filter, (val, key) => {
        if (val && key !== 'page') {
          const resultValue = String(val).split(',').join(`&${key}`)
          return `${key}${resultValue}`
        }
      })

      query.push(`status[]=${this.statusType}`)

      ContactsApi.getContactsList({
        limit,
        page: this.filter.page || 1,
        query: compact(query).join('&'),
        contactType: this.contactType,
        search: this.searchValue,
        isPartners: this.isPartners
      })
        .then((resp) => {
          resp.data.clients = filter(resp.data.clients, item => item)
          if (check) {
            this.checkedContacts.push(...resp.data.clients)
            this.allContactsChecked = resp.data.totalDocs
            this.loaderRun = false
            return
          }
          this.countriesList = countriesList
          this.loaderRun = false
          this.contactsList = resp.data
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    deleteContact (id) {
      const index = findIndex(this.contactsList.clients, {id: id})
      this.deleteConfirmIndex = false
      this.contactsList.clients.splice(index, 1)
      this.openDoubleDelete = false
      ContactsApi.deleteContact(id)
        .then((resp) => {
        })
        .catch((err) => {
          console.error(err)
        })
    },
    getUserList () {
      UsersListApi.getUsersList({limit: 100})
        .then((resp) => {
          this.users = filter(resp.data.users, item => item)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    async getUsersListSelect () {
      const { PROJECT_MANAGER, BUSINESS_CONSULTANT } = departmentCategory
      const body = {
        department: [`department[]=${PROJECT_MANAGER}`, `department[]=${BUSINESS_CONSULTANT}`]
      }
      try {
        const { data } = await UserApi.getUsersListSelect(body)
        data.forEach((item) => {
          const { position = [] } = item
          const [currentItem] = position
          const { department } = currentItem
          if (department === BUSINESS_CONSULTANT) {
            this.columnBc.items.push(item)
          } else {
            this.columnPm.items.push(item)
          }
        })
      } catch (err) {
        console.error(err)
      }
    },
    async getSelectPartner () {
      try {
        const { data } = await ContactsApi.getSelectPartner()
        const { partners } = data
        if (this.filter['isPartner=']) {
          this.columnPartner.isActiveAll = true
          this.columnPartner.activeClass = true
        }
        const partner = partners.find((el) => el._id === this.filter['partner[]='])
        if (partner) {
          partner.isActive = true
          this.columnPartner.activeClass = true
        }
        this.columnPartner.options = partners
      } catch (err) {
        console.error(err)
      }
    },
    async getClientByDepartment () {
      const body = {
        isBusiness: true,
        isContact: true,
        contactType: this.contactType
      }
      try {
        const { data } = await ContactsApi.getClientByDepartment(body)
        const { businessConsultants = [], projectManagers = [] } = data

        this.setActiveFilter(businessConsultants, projectManagers)
        this.columnBc.options = businessConsultants
        this.columnPm.options = projectManagers
      } catch (err) {
        console.error(err)
      }
    },
    setActiveFilter (businessConsultants, projectManagers) {
      const bm = 'businessConsultant[]='
      const pm = 'projectManager[]='
      const currentBc = businessConsultants.find((el) => el._id === this.filter[bm])
      const currentPm = projectManagers.find((el) => el._id === this.filter[pm])
      if (currentBc) {
        currentBc.isActive = true
        this.columnBc.activeClass = true
      }
      if (currentPm) {
        currentPm.isActive = true
        this.columnPm.activeClass = true
      }
    },
    setFilterValue (filter, value) {
      filter.forEach((el) => {
        set(value, el, true)
      })
    },
    getFiltersPars () {
      const filterKey = [
        {
          key: 'banks.bankName[]=',
          value: this.filterByBank
        },
        {
          key: 'status[]=',
          value: this.filterByStatus
        },
        {
          key: 'passports.citizenship[]=',
          value: this.filterByCitizenship
        },
        {
          key: 'riskStatus[]=',
          value: this.filterByRisk
        },
        {
          key: 'languages[]=',
          value: this.filterByLang
        },
        {
          key: 'phone[]=',
          value: this.filterByExtra
        },
        {
          key: 'email[]=',
          value: this.filterByExtra
        }
      ]

      filterKey.forEach((item) => {
        const { key, value } = item
        if (!this.filter[key]) return
        this.setFilterValue(this.filter[key].split(','), value)
      })
    },
    async onUpdateClient ({ row, column, value }) {
      const { prop } = column
      const { id } = row
      const [currentItem] = value
      try {
        await ContactsApi.editContactByField(id, {[prop]: currentItem.id || currentItem._id})
      } catch (err) {
        console.error(err)
      }
    },
    onChangeFilter (item, value, isAll) {
      this.filterByImage(value._id, item, isAll)
    },
    onFilterClick (prop) {
      this.filterOpen = prop
    },
    getContacts () {
      this.checkedContacts = []
      if (this.resetClientCheck) {
        this.resetClientCheck = false
        return
      }
      this.filterByStatus = {}
      this.filterByCitizenship = {}
      this.filterByRisk = {}
      this.filterByBank = {}
      this.filterByLang = {}
      this.filter = {}
      this.$router.replace({query: this.filter}).catch(err => err)
      this.getContactsList({limit: this.defLimit})
      this.getClientByDepartment()
      this.clientCheckedNotEmail = false
    }
  },
  watch: {
    checkedContacts () {
      this.$emit('checkedClient', this.checkedContacts)
    },
    statusType () {
      this.getContacts()
    },
    contactType () {
      this.getContacts()
    },
    searchValue (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getWithSearch({page: 1, limit: this.defLimit})
      }
    },
    activeCompany () {
      this.getContactsList({limit: this.defLimit})
    }
  },
  beforeMount () {
    const { location } = window
    this.filter = queryString.parse(location.search)
    this.clientCheckedNotEmail = this.$route.params.clientCheckedNotEmail !== undefined
    this.resetClientCheck = this.$route.params.resetClientCheck !== undefined
    if (!this.clientCheckedNotEmail) {
      this.getContactsList({limit: this.defLimit})
    }
    if (this.users.length === 0 || this.users[0].company !== this.activeCompany) {
      this.getUserList()
    }
    this.getUsersListSelect()
    this.getClientByDepartment()
    this.getSelectPartner()
    this.getFiltersPars()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../sass/variables";
@import "../../../../../sass/mixins";

.bb-clients-list {
  position: relative;
  width: 100%;
  background-color: $color-white;
  box-shadow: 0 0 20px rgba($color-black, 0.05);
  border-radius: 0 5px 5px 5px;
  z-index: 0;

  &__hover-cell {
    cursor: pointer;
    transition: 0.3s;

    &:hover {
      color: $color-accent;
    }
  }

  &-banks {
    padding: 10px 0;
    display: grid;
    grid-gap: 8px;
    align-items: center;
  }

  &__flags {
    display: grid;
    grid-template-columns: repeat(auto-fill, 22px);
    grid-gap: 5px;
    align-items: center;
    height: 22px;
  }

  &__filter {
    width: 360px;
    top: 24px;
    right: 0;
    overflow: hidden;

    &_banks {
      width: 180px;
    }

    &_status {
      width: auto;
    }

    &_extra {
      width: 158px;
    }
  }

  &-avatar {
    position: relative;
    margin-right: 12px;
    cursor: pointer;

    &-icons {
      position: absolute;
      bottom: -7px;
      display: grid;
      align-items: center;
      grid-template-columns: 14px 14px;

      &__icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 14px;
        height: 14px;
        background-color: $color-white;
        border-radius: 50%;
        color: $color-accent;
        font-size: 8px;

        &_phone {
          grid-column: 2;
        }
      }
    }
  }

  .bb-table-header__item {
    &:first-child:not(.bb-table-header__item_without-toolbar) {
      width: 20px;
    }

    &:last-child:not(.bb-table-header__item_without-toolbar) {
      width: 20px;
    }
  }

  @media (max-width: 1440px) {
    .bb-table-header__item {
      padding-right: 10px;
    }

    .bb-table-body__item {
      padding-right: 10px;
    }
  }

  .phone-item-icon {
    margin-left: 7px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactsTable/ContactsTable.vue